import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ICommonButtonProps } from '../../../types/button';

export const RefreshButton = ({ onClick }: ICommonButtonProps) => {
  return (
    <>
      <IconButton
        onClick={() => {
          onClick();
        }}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
        }}
      >
        <RefreshIcon fontSize="small" />
      </IconButton>
    </>
  );
};
